// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

import DismissController from "./dismiss_controller"
application.register("dismiss", DismissController)

import PrintController from "./print_controller"
application.register("print", PrintController)

import AdminDocumentDropController from "./admin_document_drop_controller"
application.register("admin-document-drop", AdminDocumentDropController)

import TrixUploadController from "./trix_upload_controller"
application.register("trix-upload", TrixUploadController)

import PasswordValidationController from "./password_validation_controller"
application.register("password-validation", PasswordValidationController)

import FeedbackWidgetController from "./feedback_widget_controller"
application.register("feedback-widget", FeedbackWidgetController)

import SubmenuController from "./submenu_controller"
application.register("submenu", SubmenuController)

import MinutesUploadController from "./minutes_upload_controller"
application.register("minutes-upload", MinutesUploadController)

import BusinessItemsController from "./business_items_controller"
application.register("business-items", BusinessItemsController)

import PdfViewerController from "./pdf_viewer_controller"
application.register("pdf-viewer", PdfViewerController)

import HandbookRecordFormController from "./handbook_record_form_controller"
application.register("handbook-record-form", HandbookRecordFormController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import AccessRevealController from "./access_reveal_controller"
application.register("access-reveal", AccessRevealController)

import MobileNavController from "./mobile_nav_controller"
application.register("mobile-nav", MobileNavController)
